/**
 * La grille d'un tableau de bord — le SEUL endroit où un widget peut entrer.
 *
 * Un tableau de bord se compose DANS une grille, jamais au niveau supérieur du
 * canevas : le « + » n'y offre que des blocs de page et la grille elle-même, les
 * widgets étant réservés aux cellules (cf. `catalogAccept` dans BuilderCanvas).
 * Un tableau sans grille n'a donc AUCUN point d'insertion — l'écran paraît
 * normal, et rien ne peut y être ajouté.
 *
 * D'où `withDashboardGrid`, appliqué à CHAQUE lecture du blob `field_layout` et
 * pas seulement à l'ouverture : le blob d'un tableau jamais enregistré est vide,
 * et le rafraîchissement déclenché par l'assistant relisait ce vide — emportant
 * la grille posée à l'ouverture, sans erreur ni trace.
 *
 * Module à part (et non un helper de BuilderCanvas.jsx) pour rester testable
 * sans monter le canevas : un export non-composant dans un `.jsx` casse le Fast
 * Refresh de Vite.
 */

/** Le type du bloc-grille. Doit rester aligné sur le sidecar (drupal-client.js). */
export const DASHBOARD_GRID_TYPE = 'DashboardGridLayout'

/**
 * Une grille vide. `syncUrls: null` la garde éditable par l'état de page (pas de
 * DataSync par unité) : c'est la sauvegarde unique du tableau qui la persiste.
 */
export const makeDashboardGridBloc = () => ({
  id: crypto?.randomUUID ? crypto.randomUUID() : `g-${Date.now()}`,
  type: DASHBOARD_GRID_TYPE,
  data: { cells: [] },
  layout: {},
  hiddenOn: [],
  syncUrls: null,
})

/** Les blocs du serveur, garantis composables : une grille vide si le blob l'est. */
export const withDashboardGrid = (blocs) => (
  Array.isArray(blocs) && blocs.length > 0 ? blocs : [makeDashboardGridBloc()]
)
